"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import React from "react";
import $ from "jquery";
import _ from "underscore";
import AcertusShipmentApproval from "./acertus_shipment_approval";
import ActivityStreamHelper from "../../helpers/activity_stream";
import Api from "../../api/api";
import ApiService from "../../services/api_service";
import AuditBillingConfirmation from "./audit_billing_confirmation";
import Auth from "../../util/auth";
import AutoConfirmedLoadHeader from "../auto_confirmed_load_header";
import Blocker from "../blocker";
import Carrier from "../model/carrier";
import CarrierInvoiceHelper from "../../helpers/carrier_invoice";
import CarrierInvoiceHeader from "../confirm_and_submit/carrier_invoice_header";
import CarrierInvoiceLabelsEditor from "../carrier_invoice/labels_editor";
import CarrierPayableChooser from "../carrier_invoice/carrier_payable_chooser";
import CarrierService from "../../services/carrier_service";
import classNames from "classnames";
import CloseReply from "../close_reply";
import DynamicForm from "./dynamic_form";
import DisablingButton from "../../components/disabling_button";
import DocumentBrowser from "../react_document_browser";
import documentEditor from "../document_editor";
import DocumentInformation from "./document_information";
import DocumentTitle from "react-document-title";
import DocumentTypesSetter from "./document_types_setter";
import { nextPageFunctionForRule } from "../../helpers/exceptions_advance_pages";
import ExceptionSender from "../exception_sender";
import CarrierInvoicesStore from "../../stores/carrier_invoices_store";
import EmailHelper from "../../helpers/email_message";
import get from "../data/get";
import Immutable from "immutable";
import IndexerHeader from "./indexer_header";
import InvoiceAbandoner from "../invoice_abandoner";
import fetch from "../../util/fetch";
import Labels from "../labels";
import LoadDetailInformation from "./load_detail_information";
import LoadEmailCreator from "../load_email_creator";
import loadHelper from "../loads";
import LtlConfirmHeader from "./ltl_confirm_header";
import PaymentInformation from "./payment_information";
import PaymentStrategyEditor from "./payment_strategy_editor";
import PresenceList from "../presence";
import PreviousInvoiceInformation from "./previous_invoice_information";
import ReactCursor from "../../util/react/cursor";
import RemoveFromWaiting from "../remove_from_waiting";
import RulesAndExceptions from "./rules_and_exceptions";
import SelectionList from "../../util/selection_list";
import ToDashboardWithFilters from "../ui/to_dashboard_with_filters";
import UnidentifiedDocumentHelper from "../../helpers/unidentified_document";
import s from "underscore.string";
import {
  GroupedDocumentBrowserModel,
  UngroupedGroupCreator
} from "../grouped_document_browser_model";
import { History } from "react-router";
import { ReplyProgressBar, IndexerProgress } from "../progress_bars";
import generalFormatter from "../../formatters/general";
import Account from "../../api/account";
import * as popout from "./../popout";
import { BILLING_TYPE, PAYMENT_TYPE } from "./new_exception";
import {
  CARRIER_INVOICE_MODEL_OBJECT_TYPE,
  LOAD_SHIPMENT_MODEL_OBJECT_TYPE
} from "../../api/exception_events";
import { CarrierInvoice } from "../domain/carrier_invoice";
import {
  addToIgnoredItems,
  maybePrefetchNextFlowModeItem,
  isInNewFlowMode,
  isInExceptionFlowMode
} from "../flow_mode/flow_mode_service";
import { isAuditMode } from "../index_audit_split_mode";
import { isLtlReconcileEnabled } from "../ltl/reconcile";
import { setPOD } from "../../helpers/documents";
import { escapeRegExp } from "../../util/strings";
import loadDocumentRelationshipService from "../../services/load_document_relationship_service";
const selectionList = SelectionList(_.identity);
const throttle = (fn, delay) => {
  const shared = {};
  return (...params) => {
    const last = Date.now();
    shared.last = last;
    setTimeout((_2) => shared.last === last && fn(...params), delay);
  };
};
const LoadDetail = React.createClass({
  mixins: [History],
  onPopoutListenerName: "load_detail",
  getInitialState: function() {
    const labels = this.carrierInvoice() ? this.carrierInvoice().labels : [];
    return {
      note: null,
      payment: {},
      missingRequiredFields: void 0,
      shipmentAssignmentListeners: {},
      carrierInvoice: this.props.carrierInvoice,
      factoringCompany: null,
      cleanedSourceInvoiceNumber: (this.props.carrierInvoice || {}).cleaned_source_invoice_number,
      editedPaymentFields: {},
      isUnIgnoring: false,
      browserExpanded: false,
      shipments: {},
      immutable: Immutable.Map({
        isEditingLabels: false,
        isSaving: false,
        selectedLabels: selectionList.newList(labels)
      }),
      shipmentUpdate: {},
      messageOrException: "sendMessage",
      v3ReskinEnabled: this.props.v3ReskinEnabled,
      deliveryDocumentSelections: this.initialDeliveryDocuments()
    };
  },
  initialDeliveryDocuments: function() {
    var _a, _b;
    return (((_a = this.props.carrierInvoice) == null ? void 0 : _a.delivery_documents) || []).concat(
      ((_b = this.props.load) == null ? void 0 : _b.nidf_delivery_documents) || []
    );
  },
  componentWillReceiveProps: function(newProps) {
    this.evaluateProps(newProps);
    if (this.props.load && newProps.load && this.props.load.id !== newProps.load.id) {
      this.updateShipments(get.tmsShipments(newProps.load.load));
    }
    if (this.props.model !== newProps.model) {
      $(newProps.model).on(
        "document-browser-model:page-selected",
        this.pageSelected
      );
      $(this.props.model).off(
        "document-browser-model:page-selected",
        this.pageSelected
      );
    }
    if (this.props.carrierInvoice !== newProps.carrierInvoice && newProps.carrierInvoice) {
      this.updateFactoringCompany(newProps.carrierInvoice);
    }
  },
  updateFactoringCompany: function(carrierInvoice) {
    const self = this;
    Api.FactoringCompanies.byCarrierInvoiceId(carrierInvoice.id).then(
      function(data) {
        if (data && data.factoring_companies) {
          const factoringCompany = data.factoring_companies[0];
          self.setState({ factoringCompany });
        }
      }
    );
  },
  evaluateProps: function(props_) {
    this.resetViewAfterAddingDocument(props_);
    if (this.shouldHardUpdateCarrierInvoice(props_)) {
      this.setState({ carrierInvoice: props_.carrierInvoice });
      this.setState({
        cleanedSourceInvoiceNumber: props_.carrierInvoice.cleaned_source_invoice_number
      });
    }
  },
  shouldHardUpdateCarrierInvoice: function(props_) {
    const stateInvoiceId = this.state.carrierInvoice ? this.state.carrierInvoice.id : null;
    return props_.carrierInvoice && props_.carrierInvoice.id != stateInvoiceId;
  },
  resetViewAfterAddingDocument: function(newProps) {
    if (UnidentifiedDocumentHelper.setPageFromUnidentifiedDocument(newProps.model)) {
      this.editDocumentType();
      this.setState(
        { selectedComponent: "Documents" },
        () => this.setState({ selectedComponent: null })
      );
    }
  },
  componentDidMount: function() {
    if (this.carrierInvoice() && _.isNull(this.carrierInvoice().amount_to_pay)) {
      this.carrierInvoice().amount_to_pay = this.carrierInvoice().source_invoice_amount;
      this.saveCarrierInvoice(this.carrierInvoice());
    }
    this.evaluateProps(this.props);
    if (!this.creatingLoad()) {
      this.setMissingRequiredFields(false);
    }
    this.updateShipments(get.tmsShipments(this.props.load.load));
    if (this.carrierInvoice()) {
      this.updateFactoringCompany(this.carrierInvoice());
    }
    popout.registerOnPopoutToggleListener(
      this.onPopoutListenerName,
      this.onPopoutToggle
    );
    maybePrefetchNextFlowModeItem(this.props.location);
  },
  updateShipments(shipmentsList) {
    const shipments = shipmentsList.reduce((acc, s2) => {
      acc[s2.id] = s2;
      return acc;
    }, {});
    this.setState({ shipments });
  },
  componentWillMount: function() {
    $(this.props.model).on(
      "document-browser-model:page-selected",
      this.pageSelected
    );
    this.pageSelected();
  },
  componentWillUnmount: function() {
    $(this.props.model).off(
      "document-browser-model:page-selected",
      this.pageSelected
    );
    popout.unregisterOnPopoutToggleListener(this.onPopoutListenerName);
  },
  onPopoutToggle: function() {
    if (this.isMounted()) {
      this.forceUpdate();
    }
  },
  validCarrierAddress: function() {
    const carrier = this.carrier();
    return carrier && carrier.payment_address && carrier.payment_address["valid_address?"];
  },
  setMissingRequiredFields: function(fields) {
    this.setState({ missingRequiredFields: fields });
  },
  possibleProgressBar: function() {
    if (!isLtlReconcileEnabled(this.carrierInvoice())) {
      if (this.props.location.query.fromReply === "true") {
        return /* @__PURE__ */ React.createElement(ReplyProgressBar, { stepNumber: "3" });
      } else if (s.startsWith(this.props.location.pathname, "/index-document-batches")) {
        return /* @__PURE__ */ React.createElement(
          IndexerProgress,
          {
            stepNumber: 4,
            location: this.props.location,
            batchId: this.batchIdFromURL()
          }
        );
      }
    }
  },
  carrierInvoiceLabels: function() {
    return _.map(this.carrierInvoice().labels, (label) => {
      if (_.isObject(label)) {
        return label.name;
      } else {
        return label;
      }
    });
  },
  editLabels: function() {
    this.setState({
      immutable: this.state.immutable.set("isEditingLabels", true).set(
        "selectedLabels",
        selectionList.newList(this.carrierInvoiceLabels())
      )
    });
  },
  cancelEditingLabels: function() {
    this.setState({
      immutable: this.state.immutable.set("isEditingLabels", false)
    });
  },
  saveLabels: function() {
    const newState = this.state.immutable.set("isEditingLabels", false);
    const carrierInvoice = this.state.carrierInvoice;
    carrierInvoice.labels = this.state.immutable.get("selectedLabels").toJS();
    this.setState({ immutable: newState, carrierInvoice });
    this.saveInvoice();
  },
  render: function() {
    const invoice = this.carrierInvoice();
    const nextFlowModeItem = () => {
      console.log("Flow Mode: Debug move next");
      ToDashboardWithFilters(this.props.location, this.history);
    };
    const flowModeButton = Account.newFlowModeDebuggingEnabled() && isInNewFlowMode(this.props.location.query.onDone) ? /* @__PURE__ */ React.createElement("button", { onClick: nextFlowModeItem }, "Next Flow Mode Item") : null;
    const legacyContents = /* @__PURE__ */ React.createElement("div", { className: "document-container" }, this.header(), this.possibleProgressBar(), /* @__PURE__ */ React.createElement("div", { className: "document-indexer__main-body load-detail__main" }, this.leftModuleOrDocumentBrowser(invoice), this.documentBrowserOrMessage()), /* @__PURE__ */ React.createElement("div", { id: "presence" }, /* @__PURE__ */ React.createElement(
      PresenceList,
      {
        location: this.props.location,
        batchId: this.batchIdFromURL(),
        loadId: this.props.load.id
      }
    )));
    const contents = this.state.v3ReskinEnabled ? this.v3ReskinContents() : legacyContents;
    return /* @__PURE__ */ React.createElement(Blocker, { "data-component": "LoadDetail", modalView: this.possibleModalView() }, /* @__PURE__ */ React.createElement("div", null, flowModeButton, /* @__PURE__ */ React.createElement(
      DocumentTitle,
      {
        title: `Load ${this.props.load.load.load_id} -- Confirm and submit`
      },
      contents
    )));
  },
  leftModuleOrDocumentBrowser: function(invoice) {
    if (this.state.browserExpanded) return null;
    if (this.state.leftSelected) {
      const group = this.state.leftSelected.group;
      const page = this.state.leftSelected.page;
      const documents = this.showDocumentBrowser(page, group);
      return /* @__PURE__ */ React.createElement("div", { className: "xlarge-4 small-5 column load-detail__left-side-document-browser-area" }, /* @__PURE__ */ React.createElement("div", { className: "load-detail__left-side-document-browser" }, documents));
    }
    return this.leftModule(invoice);
  },
  showDocumentBrowser: function(selectedPage, group) {
    const model = this.documentBrowserModel();
    model.selectedPage = selectedPage;
    model.groups = [group];
    return /* @__PURE__ */ React.createElement(
      DocumentBrowser,
      {
        model,
        closeBrowser: this.closeLeftSideDocumentBrowser,
        collapseSingleGroup: false,
        allowsEditingPodStatus: false,
        canEditDocumentType: false,
        carrier: this.carrier(),
        shipments: this.state.shipments,
        documentLoadRelationships: this.props.documentLoadRelationships
      }
    );
  },
  closeLeftSideDocumentBrowser: function() {
    this.setState({ leftSelected: null });
  },
  documentBrowserModel: function() {
    return new GroupedDocumentBrowserModel(
      new UngroupedGroupCreator(this.state.leftSelected.group.documents),
      function() {
        return false;
      },
      void 0
    );
  },
  batchIdFromURL: function() {
    const match = this.props.location.pathname.match(
      /index-document-batches\/(\d+)\//
    );
    if (match) {
      return match[1];
    }
  },
  leftModule: function(invoice) {
    let actionAreaClassName = "load-detail__action-area";
    if (Account.auditBillingEnabled()) {
      actionAreaClassName = "load-detail__audit-billing-action-area";
    }
    const moduleClassName = "small-5 xlarge-4 column load-detail__container " + actionAreaClassName;
    if (this.state.editingDocumentType) {
      return /* @__PURE__ */ React.createElement("div", { className: moduleClassName }, /* @__PURE__ */ React.createElement(
        DocumentTypesSetter,
        {
          model: this.props.model,
          onUpdate: this.typeUpdated,
          onComplete: this.typeComplete,
          stayOnPageAfterSetting: true,
          documentIndexerService: this.props.documentIndexerService
        }
      ));
    }
    if (this.carrierInvoice()) {
      var standardHeader = /* @__PURE__ */ React.createElement(
        CarrierInvoiceHeader,
        {
          carrierInvoice: this.carrierInvoice(),
          batchId: this.batchIdFromURL(),
          load: this.props.load
        }
      );
      var autoConfirmedHeader = /* @__PURE__ */ React.createElement(
        AutoConfirmedLoadHeader,
        {
          carrierInvoice: this.carrierInvoice(),
          load: this.props.load
        }
      );
      var header = this.props.load.load.load_is_auto_confirmed ? autoConfirmedHeader : standardHeader;
    } else {
      var header = null;
    }
    return /* @__PURE__ */ React.createElement("div", { className: moduleClassName }, header, this.possibleStuckInWaitingMessage(), this.possibleIgnoreReasonMessage(), this.possibleCloseReplyButton(), this.possibleOtherInvoices(), this.possibleExceptionSender(invoice), Account.auditBillingEnabled() && this.possibleBillRulesAndExceptions(), this.possibleRulesAndExceptions(), this.possibleCustomerInstructions(), this.possibleIndexing(invoice));
  },
  possibleCloseReplyButton: function() {
    if (this.approvedCarrierInvoice() && this.fromReply() && this.emailId()) {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(CloseReply, { emailId: this.emailId(), onComplete: this.loadComplete }), /* @__PURE__ */ React.createElement("span", { className: "load-detail__completion-context" }, this.props.completionContext));
    }
  },
  emailId: function() {
    return this.props.location.query.emailMessageId || this.props.location.query.emailId;
  },
  fromReply: function() {
    return _.filter(
      this.props.carrierInvoice.emails,
      (email) => !email.completed_at && email.message_type === "reply"
    ).length > 0;
  },
  invoiceActivityItems: function() {
    return this.props.load.activity_items.filter(
      (activityItem) => this.carrierInvoice() && (activityItem.owner_type === "CarrierInvoice" && this.carrierInvoice().id === activityItem.owner_id || ["DocumentPage", "TMS::LoadShipment"].includes(
        activityItem.owner_type
      ))
    );
  },
  lastIgnoreReason: function() {
    const abandonedItems = this.invoiceActivityItems().filter(
      (item) => {
        var _a;
        return item.activity_type === "invoice_abandoned" && ((_a = item.data) == null ? void 0 : _a.reason);
      }
    );
    const lastItem = abandonedItems[abandonedItems.length - 1];
    return lastItem && lastItem.data.reason;
  },
  possibleOtherInvoices: function() {
    if (this.carrierInvoice()) {
      const invoices = this.props.load.carrier_invoices;
      if (invoices.length > 1) {
        return /* @__PURE__ */ React.createElement(
          PreviousInvoiceInformation,
          {
            location: this.props.location,
            carrierInvoices: this.props.load.carrier_invoices,
            currentInvoice: this.carrierInvoice(),
            v3ReskinEnabled: this.state.v3ReskinEnabled
          }
        );
      }
    }
  },
  textToHighlightChanged(text) {
    popout.setHoveredText(text);
    this.setState({ textToHighlight: text });
  },
  advanceableTextClicked(text) {
    const hasText = (p) => _.some(p.lines, (l) => l.chars.match(escapeRegExp(text)));
    this.props.model.selectNextPageMatchingRule(hasText);
  },
  exceptionClicked(rule) {
    const nextPageFunction = nextPageFunctionForRule(rule);
    if (nextPageFunction) {
      this.props.model.selectNextPageMatchingRule(nextPageFunction);
    }
  },
  possibleRulesAndExceptions: function() {
    if (this.showExceptions()) {
      return /* @__PURE__ */ React.createElement(
        RulesAndExceptions,
        {
          readOnly: this.invoiceIsReadOnly() || this.auditBillingInvoiceIsReadOnly(),
          carrierInvoice: this.carrierInvoice(),
          load: this.props.load,
          exceptionCreator: this.buildPaymentExceptionCreator(),
          exceptionResolver: this.resolveException,
          exceptionEvents: this.carrierInvoice().exception_events,
          exceptionClicked: this.exceptionClicked,
          v3ReskinEnabled: this.state.v3ReskinEnabled
        }
      );
    }
  },
  isApprovedOrBilled(loadShipment) {
    return loadShipment.approved_at || loadShipment.billed_in_tms;
  },
  possibleBillRulesAndExceptions: function() {
    const tmsLoadShipments = this.props.load && this.props.load.load && this.props.load.load.tms_load_shipments;
    if (this.showExceptions() && tmsLoadShipments) {
      const tmsShipments = get.tmsShipments(this.props.load.load);
      const shipmentsById = _.object(
        tmsShipments.map((x) => [x.id, x])
      );
      const sortable = tmsLoadShipments.map((loadShipment) => {
        const isApprovedOrBilledOrder = this.isApprovedOrBilled(loadShipment) ? 1 : -1;
        const shipment = shipmentsById[loadShipment.tms_shipment_id];
        const externalId = shipment && shipment.external_id;
        return {
          item: loadShipment,
          sortScore: [
            isApprovedOrBilledOrder,
            // always put approved/billed to bottom
            externalId,
            // then sort by external id
            loadShipment.id
            // finally, sort by id for tie-breaking
          ]
        };
      });
      const sorted = _.sortBy(sortable, "sortScore").map((s2) => s2.item);
      const loadShipmentComponents = sorted.map((loadShipment) => {
        return /* @__PURE__ */ React.createElement(
          RulesAndExceptions,
          {
            readOnly: this.invoiceIsReadOnly(),
            loadShipment,
            carrierInvoice: this.carrierInvoice(),
            load: this.props.load,
            key: loadShipment.id,
            exceptionCreator: this.buildBillingExceptionCreator(loadShipment),
            exceptionResolver: this.buildLoadShipmentExceptionResolver(
              loadShipment
            ),
            exceptionEvents: loadShipment.exception_events,
            exceptionClicked: this.exceptionClicked,
            v3ReskinEnabled: this.state.v3ReskinEnabled
          }
        );
      });
      if (this.props.v3ReskinEnabled) {
        return /* @__PURE__ */ React.createElement(
          "div",
          {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: "var(--space-xs)"
            }
          },
          /* @__PURE__ */ React.createElement("h2", null, "Exceptions"),
          /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h4", null, "Customer"), loadShipmentComponents)
        );
      } else {
        return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "indexer-header__subject" }, "Customer Exceptions"), loadShipmentComponents);
      }
    }
  },
  exceptionsV3Reskin: function() {
    if (this.showExceptions()) {
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: "var(--space-xs)"
          }
        },
        Account.auditBillingEnabled() && this.possibleBillRulesAndExceptions(),
        this.possibleRulesAndExceptions(),
        this.internalNoteV3Reskin()
      );
    }
  },
  showExceptions: function() {
    return !!this.carrierInvoice();
  },
  possibleCustomerInstructions: function() {
    const customer = this.props.load.load.customer;
    const instructionsList = customer ? customer.instructions_list : null;
    const settings = Api.Account.currentSettings() || {};
    const billingRequirementsPopoutEnabled = settings["use_billing_reqs_popout"];
    if (!billingRequirementsPopoutEnabled && instructionsList && instructionsList.length > 0) {
      const instructionsListItems = instructionsList.map(
        (instructions, index) => {
          return /* @__PURE__ */ React.createElement("p", { key: index }, instructions);
        }
      );
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h3", { className: "load-detail__section-header" }, "Customer Instructions"), /* @__PURE__ */ React.createElement("div", null, instructionsListItems));
    } else {
      return;
    }
  },
  buildPaymentExceptionCreator: function() {
    const carrierInvoice = this.carrierInvoice();
    const loadShipments = this.loadShipments();
    return function(message, ignore, types) {
      const promises = [];
      if (types.includes(BILLING_TYPE)) {
        loadShipments.forEach((loadShipment) => {
          promises.push(
            Api.ExceptionEvents.create(
              loadShipment.id,
              LOAD_SHIPMENT_MODEL_OBJECT_TYPE,
              message
            )
          );
        });
      }
      if (types.includes(PAYMENT_TYPE)) {
        promises.push(
          Api.ExceptionEvents.create(
            carrierInvoice.id,
            CARRIER_INVOICE_MODEL_OBJECT_TYPE,
            message
          )
        );
      }
      return Promise.all(promises);
    };
  },
  buildBillingExceptionCreator: function(loadShipment) {
    const carrierInvoice = this.carrierInvoice();
    return function(message, ignore, types) {
      const promises = [];
      if (types.includes(BILLING_TYPE)) {
        promises.push(
          Api.ExceptionEvents.create(
            loadShipment.id,
            LOAD_SHIPMENT_MODEL_OBJECT_TYPE,
            message
          )
        );
      }
      if (types.includes(PAYMENT_TYPE)) {
        promises.push(
          Api.ExceptionEvents.create(
            carrierInvoice.id,
            CARRIER_INVOICE_MODEL_OBJECT_TYPE,
            message
          )
        );
      }
      return Promise.all(promises);
    };
  },
  resolveException: function(message, exception) {
    return Api.ExceptionEvents.resolve(
      this.carrierInvoice().id,
      CARRIER_INVOICE_MODEL_OBJECT_TYPE,
      message,
      exception
    );
  },
  buildLoadShipmentExceptionResolver: function(loadShipment) {
    return function(message, exception) {
      return Api.ExceptionEvents.resolve(
        loadShipment.id,
        LOAD_SHIPMENT_MODEL_OBJECT_TYPE,
        message,
        exception
      );
    };
  },
  typeUpdated: function(document) {
    this.forceUpdate();
    this.removeDeliveryDocumentSelectionsForDocument(document);
    Api.Documents.save(document);
  },
  typeComplete: function() {
    if (this.carrierInvoice()) {
      Api.CarrierInvoices.runRules(this.carrierInvoice().id);
    }
    this.setState({ editingDocumentType: false });
  },
  editDocumentType: function() {
    this.setState({ editingDocumentType: true });
  },
  approvedCarrierInvoice: function() {
    const carrierInvoice = this.carrierInvoice();
    return carrierInvoice && new CarrierInvoice(carrierInvoice, this.props.load).isApproved();
  },
  approvedWaitingInvoice: function() {
    return this.approvedCarrierInvoice() && this.carrierInvoice().active_exceptioned_item;
  },
  possibleStuckInWaitingMessage: function() {
    if (this.approvedWaitingInvoice()) {
      return /* @__PURE__ */ React.createElement(
        RemoveFromWaiting,
        {
          itemId: this.carrierInvoice().active_exceptioned_item.id,
          onComplete: this.loadComplete
        }
      );
    }
  },
  possibleIgnoreReasonMessage: function() {
    if (this.carrierInvoice() && this.carrierInvoice().state === "abandoned") {
      const reason = this.lastIgnoreReason();
      return /* @__PURE__ */ React.createElement("div", { className: "alert-box warning" }, "Ignore reason: ", reason || "No Ignore Reason Provided");
    }
  },
  title: function() {
    if (this.state.sendingException) {
      return "Send Exception Message";
    }
    return "Confirmation";
  },
  possibleExceptionSender: function(invoice) {
    const settings = Api.Account.currentSettings() || {};
    if (this.state.sendingException && invoice.active_exceptioned_item) {
      const exceptionedItemId = invoice.active_exceptioned_item.id;
      const templateVariables = Api.Account.current().payables_template_variables;
      const defaultEmail = new LoadEmailCreator(
        this.props.load,
        this.carrierInvoice(),
        Auth._currentUser,
        settings.custom_exception_email_subject_template,
        settings.custom_exception_email_body_template,
        templateVariables,
        this.carrier()
      ).initialEmail();
      let contacts;
      if (settings.only_show_load_contacts_for_exception_emails) {
        contacts = [];
      } else {
        contacts = this.carrier().contacts;
      }
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
        ExceptionSender,
        {
          documents: this.props.model.allDocuments(),
          onComplete: this.loadComplete,
          carrierInvoice: this.carrierInvoice(),
          carrier: this.carrier(),
          factoringCompany: this.state.factoringCompany,
          defaultEmail,
          possibleLoad: this.props.load,
          parent: this.props.email || _.findWhere(this.props.carrierInvoice.emails || [], {
            id: parseInt(this.props.location.query.emailMessageId)
          }),
          contacts,
          hasMore: this.hasMore(),
          canCancel: true,
          cancel: this.cancelException,
          exceptionedItemId,
          multipleExceptionMessagesEnabled: settings.multiple_custom_exception_templates,
          customEmailTemplates: settings.custom_exception_email_templates,
          templateVariables
        }
      ));
    }
  },
  hasMore: function() {
    return this.props.location.query && this.props.location.query.hasMore === "true";
  },
  loadComplete: function() {
    ToDashboardWithFilters(this.props.location, this.history);
  },
  cancelException: function() {
    this.setState({ sendingException: false });
  },
  possibleIndexing: function(invoice) {
    if (this.carrierInvoice() && !this.state.sendingException) {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("hr", null), this.possibleSaveButtons(invoice), this.possibleAuditBillingOrSaveWithErrorsButton(), /* @__PURE__ */ React.createElement("span", { className: "load-detail__right-buttons-wrapper" }, this.possibleUnIgnoreButton(), this.possibleReturnToDashboardOrNextGroupButton()), this.possibleDocumentInformation(invoice), this.possiblePaymentInformation(), this.possibleLoadCreationFields(), this.possibleAcertusShipmentApproval(), this.carrierPayable(), popout.isDocumentViewerOpen() ? /* @__PURE__ */ React.createElement("div", null) : this.possibleLoadDetailInformation(), this.labels());
    } else if (!this.state.sendingException) {
      return /* @__PURE__ */ React.createElement("div", null, popout.isDocumentViewerOpen() ? /* @__PURE__ */ React.createElement("div", null) : this.possibleLoadDetailInformation());
    }
  },
  addShipmentAssignmentListener(name, fn) {
    this.state.shipmentAssignmentListeners[name] = fn;
  },
  possibleAcertusShipmentApproval() {
    const settings = Api.Account.currentSettings() || {};
    if (settings.feature_enable_per_shipment_approval) {
      const hasAssignedPod = (shipment) => {
        return this.state.shipments[shipment.id] && this.state.shipments[shipment.id].meets_pod_requirements;
      };
      return /* @__PURE__ */ React.createElement(
        AcertusShipmentApproval,
        {
          hasAssignedPod,
          onUpdate: this.updateExceptions,
          addShipmentAssignmentListener: this.addShipmentAssignmentListener,
          load: this.props.load.load,
          carrierInvoice: this.props.carrierInvoice,
          shipmentUpdate: this.state.shipmentUpdate,
          key: this.props.carrierInvoice.id
        }
      );
    } else {
      return null;
    }
  },
  updateExceptions() {
    this.saveCarrierInvoice(this.state.carrierInvoice);
  },
  possibleLoadCreationFields: function() {
    const { fields, defaults } = this.loadCreationExtractedFieldSettings();
    const load = this.props.load.load || {};
    const initial = this.initialCreationFields({ fields, defaults, load });
    if (this.creatingLoad()) {
      return /* @__PURE__ */ React.createElement(
        DynamicForm,
        {
          fields,
          onFormUpdate: throttle(this.updateLoad, 1e3),
          form: initial,
          customer: load.customer
        }
      );
    }
  },
  initialCreationFields({ fields, defaults, load }) {
    const keys = this.extractKeysFrom({ fields }, ["id"]);
    return keys.reduce((obj, key) => {
      obj[key] = load[key] || load.data[key] || defaults[key];
      return obj;
    }, {});
  },
  extractKeysFrom(field, keys = []) {
    if (field.fields) {
      return keys.concat(
        field.fields.reduce(
          (keys2, field2) => this.extractKeysFrom(field2, keys2),
          []
        )
      );
    } else {
      switch (field.type) {
        case "lookupAddress":
        case "labeledAddress":
        case "address":
          const key = field.key;
          return keys.concat([
            `${key}_name`,
            `${key}_address_line_1`,
            `${key}_address_line_2`,
            `${key}_city`,
            `${key}_state`,
            `${key}_postal_code`
          ]);
        default:
          return keys.concat([field.key]);
      }
    }
  },
  updateLoad(hasError, load, setErrorMessages) {
    var load_details = this;
    if (hasError) {
      load_details.setMissingRequiredFields(true);
    } else {
      load_details.setMissingRequiredFields(false);
    }
    return ApiService.addErrorHandler(
      fetch("/api/tms/loads/" + load.id, {
        method: "PUT",
        data: { load: __spreadProps(__spreadValues({}, load), { data: void 0 }) }
      }).then(function(response) {
        if (response.errors) {
          load_details.setMissingRequiredFields(true);
          setErrorMessages(response.errors);
        } else {
          setErrorMessages({});
        }
      }),
      null,
      { caller: "LoadDetail.updateLoad" }
    );
  },
  loadCreationExtractedFieldSettings: function() {
    const fields = Api.Account.currentSettings().load_creation_extracted_fields;
    const extractDefaults = (defaults, field) => field.fields ? __spreadValues(__spreadValues({}, defaults), field.fields.reduce(extractDefaults, {})) : __spreadProps(__spreadValues({}, defaults), { [field.key]: field.default });
    return { fields, defaults: extractDefaults({}, { fields }) };
  },
  creatingLoad: function() {
    const load = this.props.load.load;
    return !load.sent_to_tms_at && load.source_system === "hubtran";
  },
  possibleLoadDetailInformation: function() {
    if (!this.creatingLoad()) {
      return /* @__PURE__ */ React.createElement(
        LoadDetailInformation,
        {
          onTextToHighlightChanged: this.textToHighlightChanged,
          advanceableTextClicked: this.advanceableTextClicked,
          model: this.props.model,
          load: this.props.load,
          invoice: this.props.carrierInvoice
        }
      );
    }
  },
  header: function() {
    var _a, _b;
    let headerSource = this.props.email;
    if (!this.props.email) {
      headerSource = {
        subject: "Load: " + this.props.load.load.load_id,
        sender_address: "",
        created_at: this.props.load.created_at
      };
    }
    const displayReference = Account.currentSettings().display_load_reference_as_title;
    const tmsLoad = (_a = this.props.load) == null ? void 0 : _a.load;
    const isLtlAuditCustomer = Api.Account.currentSettings().ltl_reconcile_enabled && Api.Account.currentSettings().index_audit_split_enabled;
    const className = this.state.v3ReskinEnabled ? "" : "document-indexer__header" + (isLtlAuditCustomer ? " document-indexer__header--ltl" : "");
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className }, /* @__PURE__ */ React.createElement(
      IndexerHeader,
      {
        email: headerSource,
        actions: this.actions(),
        load: tmsLoad,
        invoice: this.props.carrierInvoice,
        displayReference,
        isLtlAuditCustomer,
        v3ReskinEnabled: this.state.v3ReskinEnabled,
        carrierInvoices: (_b = this.props.load) == null ? void 0 : _b.carrier_invoices
      }
    )), isLtlReconcileEnabled(this.carrierInvoice()) && !this.state.v3ReskinEnabled && /* @__PURE__ */ React.createElement(
      LtlConfirmHeader,
      {
        invoice: this.carrierInvoice(),
        load: tmsLoad,
        location: this.props.location
      }
    ));
  },
  v3ReskinContents: function() {
    const divider = /* @__PURE__ */ React.createElement(
      "div",
      {
        style: {
          width: "100%",
          height: "1px",
          background: "var(--color-navy-400)"
        }
      }
    );
    const sections = [
      this.header(),
      this.possibleOtherInvoices(),
      this.exceptionsV3Reskin(),
      this.possibleDocumentInformation()
    ].filter(Boolean).map((section) => /* @__PURE__ */ React.createElement("div", { style: { margin: "var(--space-s)" } }, section)).flatMap((section, i) => i == 0 ? [section] : [divider, section]);
    return /* @__PURE__ */ React.createElement("div", { className: "enable_shared-ui-v3", style: { marginBottom: "32px" } }, /* @__PURE__ */ React.createElement("div", { className: "v3__theme audit_v3_reskin audit_v3_reskin__activate_container" }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", background: "#FDFDFD" } }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "v3__type__small-body",
        style: {
          display: "flex",
          flexDirection: "column",
          flex: 1
        }
      },
      sections
    ), /* @__PURE__ */ React.createElement("div", { style: { flex: 1 } }, this.documentBrowserOrMessage()))));
  },
  actions: function() {
    const actions = [];
    const location = this.props.location;
    if (this.canAbandonInvoice()) {
      actions.push(["Ignore Invoice", this.startAbandoningInvoice]);
    }
    if (this.invoiceIsReadOnly()) {
      actions.push(["I'm Done", this.loadComplete]);
    }
    if (Api.Account.indexAuditSplitEnabled() && isAuditMode(location) && isInNewFlowMode(location.query.onDone)) {
      if (this.props.v3ReskinEnabled) {
        actions.push(["Next", this.skipInvoice]);
      } else {
        actions.push(["Next Item", this.skipInvoice, "next-control"]);
      }
    }
    if (Api.Account.indexAuditSplitEnabled() && isInExceptionFlowMode(location)) {
      if (this.props.v3ReskinEnabled) {
        actions.push(["Next", this.skipExceptionItem]);
      } else {
        actions.push(["Next Item", this.skipExceptionItem, "next-control"]);
      }
    }
    return actions;
  },
  possibleModalView: function() {
    var _a, _b;
    if (this.state.abandoningInvoice) {
      const loadDocumentBatchId = (_b = (_a = this.props.load) == null ? void 0 : _a.document_batch_ids) == null ? void 0 : _b[0];
      return /* @__PURE__ */ React.createElement(
        InvoiceAbandoner,
        {
          abandon: this.abandonInvoice,
          documentBatchId: this.batchIdFromURL() || loadDocumentBatchId,
          isPaymentsNetworkSubmission: !!this.props.carrierInvoice.is_payments_network_submission,
          onCancel: () => this.setState({ abandoningInvoice: false }),
          markAsDuplicate: this.markInvoiceAsDuplicate
        }
      );
    }
  },
  abandonInvoice: function(reason) {
    return Api.CarrierInvoices.abandon(this.carrierInvoice().id, reason).then(() => this.setState({ abandoningInvoice: false })).catch(console.error);
  },
  canAbandonInvoice: function() {
    return this.carrierInvoice() && this.carrierInvoice().state !== "abandoned" && this.carrierInvoice().state !== "approved";
  },
  startAbandoningInvoice: function() {
    this.setState({ abandoningInvoice: true });
  },
  skipInvoice: function() {
    addToIgnoredItems("load_state_ids", this.props.load.id);
    ToDashboardWithFilters(this.props.location, this.history);
  },
  skipExceptionItem: function() {
    addToIgnoredItems("load_state_ids", this.props.load.id);
    ToDashboardWithFilters(this.props.location, this.history);
  },
  invoiceIsReadOnly: function() {
    return this.carrierInvoice() && (this.carrierInvoice().state === "approved" || this.carrierInvoice().state === "abandoned");
  },
  auditBillingInvoiceIsReadOnly: function() {
    return this.carrierInvoice() && this.carrierInvoice().state === "partial_approved";
  },
  carrierInvoice: function() {
    return this.props.carrierInvoice;
  },
  markInvoiceAsDuplicate: function(documentBatchId, carrierInvoiceId) {
    return Api.DocumentBatches.ignoreAsDuplicate(
      documentBatchId,
      carrierInvoiceId
    ).then(() => this.setState({ abandoningInvoice: false })).catch(console.error);
  },
  showNoteFieldByDefault: function() {
    return !_.isEmpty(this.carrierInvoice().ignored_rules);
  },
  possibleDocumentInformation: function(args = {}) {
    if (this.hasDocuments() && this.carrierInvoice()) {
      return /* @__PURE__ */ React.createElement(
        DocumentInformation,
        {
          model: this.props.model,
          keyPressNotifier: this.keyPressNotifier,
          factoringAssignment: this.props.model.factoringAssignment(),
          updatePaymentField: this.updatePaymentField,
          source_invoice_number: this.sourceInvoiceNumber(
            this.carrierInvoice()
          ),
          source_invoice_date: this.sourceInvoiceDate(this.carrierInvoice()),
          source_invoice_amount: this.sourceInvoiceAmount(
            this.carrierInvoice()
          ),
          cleanedSourceInvoiceNumber: this.state.cleanedSourceInvoiceNumber,
          noteFieldChanged: this.noteFieldChanged,
          invoiceFieldChanged: this.invoiceFieldChanged,
          invoiceFieldsChanged: this.invoiceFieldsChanged,
          invoiceChangeComplete: () => {
          },
          toggleDocumentData: this.toggleDocumentData,
          document: this.props.model.selectedDocument,
          readOnly: this.invoiceIsReadOnly() || this.auditBillingInvoiceIsReadOnly(),
          load: this.props.load,
          quickpay: this.state.carrierInvoice.quickpay,
          carrierInvoice: this.state.carrierInvoice,
          carrier: CarrierService.getCarrierOrUnknown(
            this.carrierInvoice().carrier_id
          ),
          showNoteFieldByDefault: this.showNoteFieldByDefault(),
          currentNote: this.state.note,
          invoice_disposition: this.state.carrierInvoice.disposition,
          v3ReskinEnabled: this.state.v3ReskinEnabled,
          showInternalNoteV3Reskin: args.showInternalNoteV3Reskin
        }
      );
    }
  },
  internalNoteV3Reskin: function() {
    return this.possibleDocumentInformation({ showInternalNoteV3Reskin: true });
  },
  labels: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "load-detail__labels-container" }, /* @__PURE__ */ React.createElement("h3", { className: "load-detail__section-header load-detail__section-header__labels" }, "Labels"), /* @__PURE__ */ React.createElement("div", { style: { marginTop: "10px" } }, this.labelsOrEditor()));
  },
  labelsOrEditor: function() {
    if (!this.state.immutable.get("isEditingLabels")) {
      if (this.carrierInvoice()) {
        const labels = _.union(
          this.carrier().labels,
          this.carrierInvoice().labels
        );
        return /* @__PURE__ */ React.createElement(Labels, { labels, onEdit: this.editLabels });
      }
      return /* @__PURE__ */ React.createElement(Labels, { labels: this.carrier().labels });
    }
    const cursor = ReactCursor(this, ["immutable", "selectedLabels"]);
    return /* @__PURE__ */ React.createElement(
      CarrierInvoiceLabelsEditor,
      {
        labels: Carrier.LABELS(),
        carrierLabels: this.carrier().labels,
        selectedLabels: cursor,
        onCancel: this.cancelEditingLabels,
        onSave: this.saveLabels
      }
    );
  },
  openThumbnailLeft: function(group, page) {
    this.setState({ leftSelected: { group, page } });
  },
  documentBrowserOrMessage: function() {
    const isColumnView = !(this.state.browserExpanded || this.state.v3ReskinEnabled);
    const classes = classNames({
      "x-large-6": isColumnView,
      "small-5": isColumnView,
      "small-10": !isColumnView,
      column: true,
      "document-indexer__document-side": true
    });
    return /* @__PURE__ */ React.createElement("div", { className: classes }, /* @__PURE__ */ React.createElement(
      DocumentBrowser,
      {
        model: this.props.model,
        toggleDocumentsCallback: this.props.toggleDocumentsCallback,
        loadDocumentsAvailable: this.props.loadDocumentsAvailable,
        selectedComponent: this.state.selectedComponent,
        location: this.props.location,
        leftSelected: this.state.leftSelected,
        isConfirmAndSubmit: true,
        load: this.props.load,
        currentInvoice: this.state.carrierInvoice,
        onPageSelected: this.pageSelected,
        toggleDocumentData: this.toggleDocumentData,
        toggleMarkIllegibleData: this.toggleMarkIllegibleData,
        toggleHiddenData: this.toggleHiddenData,
        toggleDeliveryDocument: this.toggleDeliveryDocument,
        toggleShipmentDocument: this.toggleShipmentDocument,
        toggleCarrierDocument: this.toggleCarrierDocument,
        toggleCustomerLoadDocument: this.toggleCustomerLoadDocument,
        textToHighlight: this.state.textToHighlight,
        canEditDocumentType: !this.invoiceIsReadOnly(),
        editDocumentType: this.editDocumentType,
        allowsEditing: this.props.allowsEditing,
        onContextMenu: this.openThumbnailLeft,
        expandBrowser: this.expandOrCompressBrowser,
        popoutReplacementChild: this.possibleLoadDetailInformation(),
        browserExpanded: this.state.browserExpanded,
        initialSelectedComponent: this.initialDocumentBrowserComponent(),
        additionalComponents: this.additionalBrowserComponents(),
        carrier: this.carrier(),
        allowsEditingPodStatus: true,
        shipments: this.state.shipments,
        carrierInvoice: this.props.carrierInvoice,
        deliveryDocumentSelections: this.state.deliveryDocumentSelections,
        removeDeliveryDocumentSelectionsForDocument: this.removeDeliveryDocumentSelectionsForDocument,
        updateShipments: this.updateShipments,
        documentLoadRelationships: this.props.documentLoadRelationships
      }
    ));
  },
  additionalBrowserComponents: function() {
    if (this.carrierInvoice()) {
      return _.compact([
        this.possibleMessageBrowserComponent(),
        this.activityBrowserComponent()
      ]);
    } else {
      return [];
    }
  },
  activityBrowserComponent: function() {
    return {
      label: "Activity",
      component: ActivityStreamHelper.invoiceActivity(
        this.invoiceActivityItems()
      )
    };
  },
  documentFromEmail: function(emailMessage) {
    const model = this.props.model;
    const groupId = model.selectedDocument.document_group_id;
    const emailId = emailMessage.id;
    return documentEditor.documentFromEmail(emailId, groupId);
  },
  possibleMessageBrowserComponent: function() {
    if (this.carrierInvoice().emails.length > 0) {
      const documentCreator = this.carrierInvoice().state === "approved" ? null : this.documentFromEmail;
      return {
        label: "Messages",
        component: EmailHelper.emailMessages(
          this.carrierInvoice().emails,
          documentCreator
        )
      };
    }
  },
  expandOrCompressBrowser: function() {
    this.setState({ browserExpanded: !this.state.browserExpanded });
  },
  paymentEditor: function() {
    return /* @__PURE__ */ React.createElement(
      PaymentStrategyEditor,
      {
        carrier: this.carrier(),
        onSave: this.savePaymentStrategy
      }
    );
  },
  saveAddress: function(address) {
    return CarrierService.createAddress(this.carrier(), "direct", address).then(
      () => this.saveCarrierInvoice(this.carrierInvoice())
    );
  },
  savePaymentStrategy: function(paymentStrategy, paymentDetails) {
    return CarrierService.createAddress(
      this.carrier(),
      paymentStrategy,
      paymentDetails
    ).then(() => this.saveCarrierInvoice(this.carrierInvoice()));
  },
  updateCleanedSourceInvoiceNumber: function() {
    if (this.state.carrierInvoice) {
      const updatedInvoice = CarrierInvoicesStore.find(
        this.state.carrierInvoice.id
      );
      this.setState({
        cleanedSourceInvoiceNumber: updatedInvoice.cleaned_source_invoice_number
      });
    }
  },
  saveInvoice: function(customerId) {
    this.clearTimer();
    const promise = this.saveCarrierInvoice(this.state.carrierInvoice);
    promise.then(this.updateCleanedSourceInvoiceNumber);
    return promise;
  },
  saveCarrierInvoice: function(invoice) {
    return Api.CarrierInvoices.update(invoice.id, invoice);
  },
  forwardInvoiceDocumentsToTriumph: function(invoice) {
    this.setState({ forwardingDocuments: true });
    return Api.CarrierInvoices.forwardInvoiceDocumentsToTriumph(invoice.id).then(() => {
      this.setState({ forwardingDocuments: false, documentsForwarded: true });
    }).catch(() => this.setState({ forwardingDocuments: false }));
  },
  toggleDocumentData: function(document, field) {
    let settingPod = false;
    let newPodStatus;
    if (field === "includesPOD") {
      settingPod = true;
      newPodStatus = !document.is_pod;
      setPOD(document, newPodStatus);
      loadDocumentRelationshipService.forcePodDispositionForDocument(
        document.id,
        newPodStatus
      );
    } else {
      document.data[field] = !document.data[field];
    }
    this.forceUpdate();
    if (settingPod && !newPodStatus) {
      this.removeDeliveryDocumentSelectionsForDocument(document);
    }
    const extras = settingPod ? {
      load_state_id: this.props.load.id,
      page: "confirm_and_submit",
      pod_toggled: true
    } : void 0;
    Api.Documents.save(document, extras).then((data) => {
      this.updateShipments(data.tms_shipments);
    });
  },
  removeDeliveryDocumentSelectionsForDocument: function(document) {
    this.setState({
      deliveryDocumentSelections: this.state.deliveryDocumentSelections.filter(
        (entry) => entry.document_id !== document.id
      )
    });
  },
  toggleMarkIllegibleData: function(document, page) {
    page.illegible = !page.illegible;
    Api.DocumentPages.markIllegible(page).then((exceptionEvent) => {
      if (this.state.carrierInvoice) {
        const exceptionEvents = this.state.carrierInvoice.exception_events;
        const containsEvent = exceptionEvents.map((ee) => ee.id).includes(exceptionEvent.id);
        if (containsEvent) {
          this.state.carrierInvoice.exception_events = exceptionEvents.filter(
            (ee) => ee.id != exceptionEvent.id
          );
        } else {
          this.state.carrierInvoice.exception_events.push(exceptionEvent);
        }
        CarrierInvoicesStore.addOrUpdate(this.state.carrierInvoice);
      }
    });
    this.forceUpdate();
  },
  toggleHiddenData: function(document, page) {
    const isHidden = !document.hidden;
    document.hidden = isHidden;
    Api.DocumentPages.markHidden(page, isHidden);
    popout.refreshPopout();
    this.forceUpdate();
  },
  toggleCarrierDocument: function(document, carrierId) {
    if (document.carrier_document_tms_carrier_id) {
      document.carrier_document_tms_carrier_id = null;
      Api.Documents.save(document);
      this.forceUpdate();
    } else {
      document.carrier_document_tms_carrier_id = carrierId;
      Api.Documents.setAsCarrierDocument(document, carrierId);
      this.forceUpdate();
    }
  },
  toggleDeliveryDocument: function(entry) {
    Api.Documents.setAssignedToDelivery(
      entry["document_id"],
      entry["tms_delivery_id"]
    );
    if (_.findWhere(this.state.deliveryDocumentSelections, entry)) {
      this.setState({
        deliveryDocumentSelections: _.reject(
          this.state.deliveryDocumentSelections,
          function(deliveryDocument) {
            return _.isEqual(entry, deliveryDocument);
          }
        )
      });
    } else {
      this.setState({
        deliveryDocumentSelections: [
          ...this.state.deliveryDocumentSelections,
          entry
        ]
      });
    }
  },
  toggleShipmentDocument: function(tmsShipment, document) {
    const isChecked = _.some(
      tmsShipment.shipment_documents,
      (shipmentDocument) => shipmentDocument.id === document.id
    );
    if (isChecked) {
      tmsShipment.shipment_documents = _.reject(
        tmsShipment.shipment_documents,
        function(shipmentDocument) {
          return shipmentDocument.id === document.id;
        }
      );
    } else {
      tmsShipment.shipment_documents.push({ id: document.id });
    }
    this.setState({ savingDocuments: true });
    Api.Documents.setAssignedToShipment(document, tmsShipment.id, !isChecked).then((data) => {
      this.updateShipments(data.tms_shipments);
      this.setState({ savingDocuments: false });
      for (var key in this.state.shipmentAssignmentListeners) {
        this.state.shipmentAssignmentListeners[key]();
      }
      if (this.carrierInvoice()) {
        Api.CarrierInvoices.runRules(this.carrierInvoice().id);
      }
    }).catch(() => this.setState({ savingDocuments: false }));
  },
  toggleCustomerLoadDocument: function(tmsCustomerLoad, document) {
    const isChecked = _.some(
      tmsCustomerLoad.documents,
      (customerLoadDocument) => customerLoadDocument.id === document.id
    );
    if (isChecked) {
      tmsCustomerLoad.documents = _.reject(
        tmsCustomerLoad.documents,
        function(customerLoadDocument) {
          return customerLoadDocument.id === document.id;
        }
      );
    } else {
      tmsCustomerLoad.documents.push({ id: document.id });
    }
    this.setState({ savingDocuments: true });
    Api.Documents.setAssignedToCustomerLoad(
      document,
      tmsCustomerLoad.id,
      !isChecked
    ).then(() => this.setState({ savingDocuments: false })).catch(() => this.setState({ savingDocuments: false }));
  },
  sourceInvoiceNumber: function(invoice) {
    return invoice.source_invoice_number;
  },
  sourceInvoiceDate: function(invoice) {
    return invoice.source_invoice_date;
  },
  cleanedAmount: function(invoice, field) {
    const amount = invoice[field];
    if (_.isEmpty(amount)) {
      return amount;
    }
    const cleaned = generalFormatter.cleanAmount(amount).toString() || "0.00";
    this.carrierInvoice()[field] = cleaned;
    return cleaned;
  },
  sourceInvoiceAmount: function(invoice) {
    return this.cleanedAmount(invoice, "source_invoice_amount");
  },
  invoiceAmountToPay: function(invoice) {
    return this.cleanedAmount(invoice, "amount_to_pay");
  },
  noteFieldChanged: function(note) {
    this.setState({ note });
  },
  keyPressNotifier: function(field) {
    return (event) => {
      if (event.charCode === 13) {
        this.invoiceFieldChanged(field, event.target.value);
        this.saveInvoice();
      }
    };
  },
  invoiceFieldsChanged: function(fields, values) {
    const component = this;
    const invoice = Object.assign({}, this.state.carrierInvoice);
    _.each(fields, (field) => {
      if (field === "amount_to_pay" && component.state.editedPaymentFields.amount_to_pay) {
        return;
      } else {
        invoice[field] = values[_.indexOf(fields, field)];
      }
      this.setState({ carrierInvoice: invoice }, this.updateTimer);
      this.forceUpdate();
    });
  },
  invoiceFieldChanged: function(field, value) {
    const newState = {};
    newState.carrierInvoice = Object.assign({}, this.state.carrierInvoice);
    newState.carrierInvoice[field] = value;
    if (field === "source_invoice_number") {
      newState.cleanedSourceInvoiceNumber = value;
    }
    this.setState(newState, this.updateTimer);
    this.forceUpdate();
  },
  updateTimer: function() {
    this.clearTimer();
    this.setState({
      pendingTimeout: window.setTimeout(this.saveInvoice, 1800)
    });
  },
  clearTimer: function() {
    if (this.state.pendingTimeout) {
      window.clearTimeout(this.state.pendingTimeout);
    }
  },
  pageSelected: function() {
    this.forceUpdate();
  },
  saveWithErrorButton: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "load-detail__save-buttons-fixed load-detail__save-buttons-fixed--right" }, /* @__PURE__ */ React.createElement("span", { className: "load-detail__completion-context" }, "Saving..."));
  },
  uiImprovementResolveLaterButton: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "load-detail__save-buttons-fixed load-detail__save-buttons-fixed--right" }, /* @__PURE__ */ React.createElement("span", { className: "load-detail__completion-context" }, "Process ", this.props.completionContext), /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "load-detail__button-cancel button--cancel",
        onClick: this.saveWithErrors
      },
      "Resolve Later"
    ), this.savingButton());
  },
  resolveLaterButton: function() {
    return this.uiImprovementResolveLaterButton();
  },
  auditBillingConfirmation: function() {
    return /* @__PURE__ */ React.createElement(
      AuditBillingConfirmation,
      {
        load: this.props.load,
        carrierInvoice: this.carrierInvoice(),
        carrier: this.carrier(),
        payment: this.payment(),
        messageOrException: this.state.messageOrException,
        handleSaveException: this.saveWithErrors,
        handleSendMessage: this.sendNow,
        handleApprove: this.saveAndMarkAsProcessed,
        handleMessageOrException: this.handleMessageOrException
      }
    );
  },
  handleMessageOrException: function(e) {
    this.setState({ messageOrException: e.target.value });
  },
  possibleAuditBillingOrSaveWithErrorsButton: function() {
    const isAbandoned = loadHelper.isAbandoned(this.carrierInvoice());
    const isInSavingState = this.state.savingException || this.state.savingDocuments;
    if (!isAbandoned && !this.invoiceIsReadOnly()) {
      if (Account.auditBillingEnabled() && !isInSavingState) {
        return this.auditBillingConfirmation();
      } else if (isInSavingState && !this.isApprovable()) {
        return this.saveWithErrorButton();
      } else if (!this.isApprovable()) {
        return this.resolveLaterButton();
      }
    }
  },
  possibleUnIgnoreButton: function() {
    const isAbandoned = loadHelper.isAbandoned(this.carrierInvoice());
    const isMovedToTms = loadHelper.isMovedToTmsQueue(this.carrierInvoice());
    if (isAbandoned && !isMovedToTms) {
      return /* @__PURE__ */ React.createElement(
        DisablingButton,
        {
          disabled: this.state.isUnIgnoring,
          className: "button--progress",
          onClick: this.revive,
          disabledText: "Un-Ignoring..."
        },
        "Un-Ignore This Invoice"
      );
    }
  },
  possibleReturnToDashboardOrNextGroupButton: function() {
    const isAbandoned = loadHelper.isAbandoned(this.carrierInvoice());
    if (isAbandoned) {
      return /* @__PURE__ */ React.createElement(
        DisablingButton,
        {
          disabled: this.state.isUnIgnoring,
          className: "button--progress load-detail__return-to-dashboard-button",
          onClick: this.loadComplete,
          disabledText: "Un-Ignoring..."
        },
        " ",
        this.hasMore() ? "Go To Next Group" : "Return To Dashboard"
      );
    }
  },
  revive: function() {
    this.setState({ isUnIgnoring: true });
    Api.CarrierInvoices.revive(this.carrierInvoice().id).then(
      () => this.setState({ isUnIgnoring: false })
    );
  },
  savingButton: function() {
    return /* @__PURE__ */ React.createElement("button", { className: "button--caution", onClick: this.sendNow }, "Save Exception and Send Now");
  },
  sendNow: function() {
    this.setState({ savingException: true });
    this.saveInvoice().then((result) => {
      if (!result) {
        setTimeout(() => this.sendNow(), 100);
      } else if (result.error) {
        this.setState({ savingException: false });
      } else {
        this.markAsException(true);
      }
    });
  },
  saveWithErrors: function() {
    this.setState({ savingException: true });
    this.saveInvoice().then((result) => {
      if (!result) {
        setTimeout(() => this.saveWithErrors(), 100);
      } else if (result.error) {
        this.setState({ savingException: false });
      } else {
        this.markAsException(false);
      }
    });
  },
  markAsException: function(shouldSendException) {
    const carrierInvoice = this.carrierInvoice();
    const exceptionMessages = loadHelper.allExceptionMessages(carrierInvoice, this.props.load, true, "", false).join(", ");
    Api.CarrierInvoices.markAsException(
      carrierInvoice.id,
      this.state.note,
      this.props.location.query.emailId,
      exceptionMessages,
      this.payment(),
      this.carrierInvoice().carrier_id
    ).then(() => {
      if (shouldSendException) {
        this.setState({ savingException: false, sendingException: true });
      } else {
        this.setState({ savingException: false });
        this.loadComplete();
      }
    }).catch(() => this.setState({ savingException: false }));
  },
  hasDocuments: function() {
    return this.props.model.allDocuments().length > 0;
  },
  possiblePaymentInformation: function() {
    if (this.hasDocuments()) {
      return /* @__PURE__ */ React.createElement(
        PaymentInformation,
        {
          creatingLoad: this.creatingLoad(),
          keyPressNotifier: this.keyPressNotifier,
          load: this.props.load,
          invoiceFieldChanged: this.invoiceFieldChanged,
          carrier: CarrierService.getCarrierOrUnknown(
            this.carrierInvoice().carrier_id
          ),
          canSaveAndMarkAsProcessed: this.isApprovable(),
          saveAddress: this.saveAddress,
          savePaymentStrategy: this.savePaymentStrategy,
          readOnly: this.invoiceIsReadOnly(),
          payment: this.payment(),
          onCarrierChanged: this.carrierChanged,
          invoiceChangeComplete: this.saveInvoice,
          updatePaymentField: this.updatePaymentField,
          carrierInvoice: this.carrierInvoice(),
          canEditAddress: true,
          completionContext: this.props.completionContext
        },
        this.possibleForwardInvoiceDocumentsToTriumphButton(
          this.carrierInvoice()
        )
      );
    }
  },
  possibleSaveButtons: function() {
    const STATES = { NORMAL: 0, DISABLED: 1, SAVING: 2 };
    let state = void 0;
    if (this.state.missingRequiredFields === true) {
      state = STATES.DISABLED;
    } else if (this.isSaving()) {
      state = STATES.SAVING;
    } else if (this.state.missingRequiredFields === false) {
      state = STATES.NORMAL;
    }
    if (this.savableInvoice()) {
      switch (state) {
        case STATES.SAVING:
          return /* @__PURE__ */ React.createElement("div", { className: "load-detail__save-buttons-fixed load-detail__save-buttons-fixed--right" }, /* @__PURE__ */ React.createElement("div", { className: "load-detail__save-buttons-container" }, /* @__PURE__ */ React.createElement("span", { className: "load-detail__completion-context" }, "Process ", this.props.completionContext), /* @__PURE__ */ React.createElement("div", null, this.possibleSaveButton())));
        case STATES.DISABLED:
          return /* @__PURE__ */ React.createElement("div", { className: "load-detail__save-buttons-fixed load-detail__save-buttons-fixed--right" }, /* @__PURE__ */ React.createElement("div", { className: "alert error" }, "Complete required fields to save or approve."));
        case STATES.NORMAL:
          if (Account.auditBillingEnabled()) {
            return this.auditBillingConfirmation();
          } else {
            return /* @__PURE__ */ React.createElement("div", { className: "load-detail__save-buttons-fixed load-detail__save-buttons-fixed--right" }, /* @__PURE__ */ React.createElement("div", { className: "load-detail__save-buttons-container" }, /* @__PURE__ */ React.createElement("span", { className: "load-detail__completion-context" }, "Process ", this.props.completionContext), /* @__PURE__ */ React.createElement("div", null, this.possibleSaveButton()), /* @__PURE__ */ React.createElement("div", { className: "load-detail__save-buttons-join-text" }, this.joinText()), /* @__PURE__ */ React.createElement("div", null, this.possibleSaveAndApproveButton())));
          }
      }
    }
  },
  possibleSaveButton: function() {
    if (this.isSavableFromPage() && (!this.indexAuditSplitAccount() || Auth._currentUser.auditor || Auth._currentUser.approver)) {
      return this.saveMarkProcessedAndApproveButton("Save");
    }
  },
  joinText: function() {
    if (this.saveAndSaveAndApprovedButtonsDisplayed()) {
      return "or";
    }
  },
  possibleSaveAndApproveButton: function() {
    if (this.isApprovableFromPage()) {
      return this.saveMarkProcessedAndApproveButton("Save and Approve", true);
    }
  },
  isSavableFromPage() {
    return this.savableInvoice() && !this.autoApproveAccount();
  },
  isApprovableFromPage: function() {
    const approvalIsAllowed = Auth._currentUser.approver || !this.indexAuditSplitAccount() && this.autoApproveAccount();
    const isApprovableFromPage = this.savableInvoice() && approvalIsAllowed;
    if (Account.auditBillingEnabled()) {
      return isApprovableFromPage && this.areLoadShipmentsAreApprovable();
    } else {
      return isApprovableFromPage;
    }
  },
  areLoadShipmentsAreApprovable: function() {
    return this.loadShipments().every((ls) => ls.approvable);
  },
  loadShipments: function() {
    if (this.props.load && this.props.load.load && this.props.load.load.tms_load_shipments) {
      return this.props.load.load.tms_load_shipments;
    } else {
      return [];
    }
  },
  saveAndSaveAndApprovedButtonsDisplayed: function() {
    return this.isApprovableFromPage() && !this.autoApproveAccount();
  },
  buttonsCompletionContext: function() {
    if (this.savableInvoice()) {
      return this.props.completionContext;
    }
  },
  saveMarkProcessedAndApproveButton: function(buttonText, approve) {
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
      DisablingButton,
      {
        className: "load-detail__save-and-approve button--progress",
        disabled: this.isSaving(),
        onClick: () => this.saveAndMarkAsProcessed(this.payment(), approve),
        disabledText: "Saving..."
      },
      buttonText
    ));
  },
  forwardInvoiceDocumentsToTriumphButton: function() {
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
      DisablingButton,
      {
        className: "button--forward",
        disabled: this.state.documentsForwarded || this.state.forwardingDocuments,
        disabledClassName: "button--forwarded",
        onClick: () => this.forwardInvoiceDocumentsToTriumph(this.state.carrierInvoice),
        disabledText: this.state.forwardingDocuments ? "Sending... " : "NOA Sent"
      },
      "Send NOA"
    ));
  },
  possibleForwardInvoiceDocumentsToTriumphButton: function() {
    if (this.forwardInvoiceDocs()) {
      return this.forwardInvoiceDocumentsToTriumphButton();
    } else {
      return /* @__PURE__ */ React.createElement("div", null);
    }
  },
  savableInvoice: function() {
    return !this.invoiceIsReadOnly() && this.isApprovable();
  },
  autoApproveAccount: function() {
    return Api.Account.currentSettings().autoApprove;
  },
  indexAuditSplitAccount: function() {
    return Api.Account.currentSettings().index_audit_split_enabled;
  },
  forwardInvoiceDocs: function() {
    return Api.Account.current()["triumphpay_id"] && this.carrierInvoice().emails.length > 0;
  },
  isApprovable: function() {
    if (Account.auditBillingEnabled()) {
      return this.carrierInvoice().approvable;
    } else {
      return loadHelper.isApprovable(this.carrierInvoice());
    }
  },
  isSaving: function() {
    return this.state.immutable.get("isSaving") || this.state.savingDocuments;
  },
  saveAndMarkAsProcessed: function(payment, approve) {
    this.didStartSaving();
    this.clearTimer();
    Api.CarrierInvoices.markAsProcessed(
      this.carrierInvoice().id,
      payment,
      this.carrierInvoice().carrier_id,
      this.state.note,
      approve,
      this.state.carrierInvoice
    ).then(() => this.loadComplete()).catch(() => {
      if (this.isMounted()) {
        this.setState({
          immutable: this.state.immutable.set("isSaving", false)
        });
      }
    });
  },
  didStartSaving: function() {
    this.setState({
      immutable: this.state.immutable.set("isSaving", true)
    });
  },
  payment: function() {
    const result = {};
    const invoice = this.carrierInvoice();
    if (this.state.editedPaymentFields.amount_to_pay) {
      result.amount = this.state.payment.amount_to_pay;
    } else {
      result.amount = this.invoiceAmountToPay(invoice) || this.sourceInvoiceAmount(invoice);
    }
    if (this.canModifyPaymentDueOn) {
      if (this.state.editedPaymentFields.payOn) {
        result.payOn = this.state.payment.payOn;
      } else {
        result.payOn = invoice.date_to_pay || CarrierInvoiceHelper.paymentDueOn(this.state.carrierInvoice);
      }
    } else {
      result.payOn = null;
    }
    return result;
  },
  canModifyPaymentDueOn: function() {
    return Account.carrierInvoiceCanModifyPaymentDueOn();
  },
  updatePaymentField: function(field, value) {
    const e = this.state.editedPaymentFields;
    e[field] = true;
    const payment = this.state.payment;
    payment[field] = value;
    this.setState({ editedPaymentFields: e, payment });
    if (field == "payOn") {
      this.state.carrierInvoice.date_to_pay = value;
      this.saveCarrierInvoice(this.state.carrierInvoice);
    }
  },
  carrierChanged: function(carrier) {
    if (carrier) {
      this.invoiceFieldChanged("carrier_id", carrier.id);
    }
  },
  carrier: function() {
    return this.props.carrier;
  },
  initialDocumentBrowserComponent() {
    return this.props.location.query.activeDocumentTab;
  },
  changedCarrierPayable: function(event) {
    const ci = this.state.carrierInvoice;
    ci.tms_carrier_payable_id = parseInt(event.target.value) || null;
    this.setState({ carrierInvoice: ci });
    this.saveInvoice();
  },
  carrierPayable: function() {
    if (!Account.currentSettings().uses_carrier_payables) {
      return;
    }
    const carrierPayables = this.props.load.load.tms_carrier_payables || [];
    const lineItems = this.props.load.load.line_items || [];
    const currentCarrierPayableId = this.state.carrierInvoice.tms_carrier_payable_id;
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h3", { className: "load-detail__section-header" }, "Linked Payable"), /* @__PURE__ */ React.createElement(
      CarrierPayableChooser,
      {
        carrierPayables,
        carrierInvoice: this.carrierInvoice(),
        lineItems,
        currentCarrierPayableId,
        carrier: this.carrier(),
        allowsEditing: !this.invoiceIsReadOnly(),
        onChange: this.changedCarrierPayable
      }
    ));
  }
});
export default LoadDetail;
